export const FILTER_DEFAULT_SEPARATOR = "[comma]";
export const DIGITALSUITE_WEBSITE_PUBLISHER_OVERVIEW = "digitalsuite_website_publisher_overview";
export const DIGITALSUITE_WEBSITE_AUDIENCE = "digitalsuite_website_audience";
export const DIGITALSUITE_WEBSITE_REFERRALS = "digitalsuite_website_referrals";
